export const ROLE_LABELS_SV = {
  "super-admin": "Superadministratör",
  "admin": "Administratör",
  "scheduler": "Schemaläggare",
  "payroll-manager": "Lönehanterare",
  "viewer": "Granskare",
  "user": "Användare",
};
